import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentProfileCtrl implements IController {

  agent: AgentModel;

  private currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentProfile', {
    bindings: {
      agent: '<'
    },
    template: require('./agent-profile.html').default,
    controller: AgentProfileCtrl
  });
